<template>
    <fade-up-animation :element="() => $refs.section">
        <div class="restaurant-details-section" ref="section">
            <b-container>
                <mobile-gutter>
                    <b-row>
                        <b-col
                            md="6"
                            lg="5"
                            offset-lg="1"
                        >
                            <restaurant-map
                                :lat="lat"
                                :lng="lng"
                                :address="address"
                            />
                        </b-col>

                        <b-col
                            md="5"
                            lg="4"
                            offset-md="1"
                        >
                            <restaurant-details
                                :title="title"
                                :opening-hours="openingHours"
                                :opening-hours-notice="openingHoursNotice"
                                :address="address"
                                :tel="telephoneNumber"
                                :facilities="facilities"
                                :view-menu-details="viewMenuDetails"
                                :sale-text="saleText"
                            />

                            <restaurant-delivery-providers
                                v-if="deliverooUrl || uberEatsUrl || justEatUrl"
                                :deliveroo-url="deliverooUrl"
                                :uber-eats-url="uberEatsUrl"
                                :just-eat-url="justEatUrl"
                            />
                        </b-col>
                    </b-row>
                </mobile-gutter>
            </b-container>
        </div>
    </fade-up-animation>
</template>

<script>
    import RestaurantMap from '../RestaurantMap/RestaurantMap';
    import RestaurantDeliveryProviders from '../RestaurantDeliveryProviders/RestaurantDeliveryProviders';
    import RestaurantDetails from '../RestaurantDetails/RestaurantDetails';

    export default {
        name: 'restaurant-details-section',

        components: {
            RestaurantDetails,
            RestaurantDeliveryProviders,
            RestaurantMap,
        },

        props: {
            title: {
                type: String,
                required: true,
            },

            lat: {
                type: [String, Number],
                required: true,
            },

            lng: {
                type: [String, Number],
                required: true,
            },

            address: {
                type: String,
                required: true,
            },

            openingHoursNotice: {
                type: String,
                default: '',
            },

            openingHours: {
                type: Object,
                default: () => ({}),
            },

            facilities: {
                type: Array,
                default: () => ([]),
            },

            telephoneNumber: {
                type: String,
                default: '',
            },

            deliverooUrl: {
                type: String,
                default: '',
            },

            uberEatsUrl: {
                type: String,
                default: '',
            },

            justEatUrl: {
                type: String,
                default: '',
            },

            viewMenuDetails: {
                type: Object,
                default: () => ({}),
            },

            saleText: {
                type: String,
                default: '',
            },
        },
    };
</script>

<style lang="scss" scoped>
    .restaurant-details-section {
        padding: 30px 0;

        @include media-breakpoint-up(md) {
            padding: 50px 0;
        }
    }

    .restaurant-map {
        margin-bottom: 30px;
    }

    .restaurant-details-block {
        & + & {
            margin-top: 60px;
        }
    }
</style>
